export default function Contact() {
  return (
    <section className="container">
      <div className="card">
        <h1>Contact / Help</h1>
        <p>
          If you need help with your DSP profile, website access, listing
          visibility, or general questions, please use the contact information
          below.
        </p>

        <div className="contact-grid">
          <div className="contact-box">
            <h2>General Support</h2>
            <p>Email: support@hopefulhorizonsny.com</p>
           {/* <p>Phone: (555) 123-4567</p>*/}
          </div>

          <div className="contact-box">
            <h2>Profile & Listing Help</h2>
            <p>
              Contact us if your profile is pending, needs updates, or is not
              showing on the website.
            </p>
          </div>

          <div className="contact-box">
            <h2>Hours</h2>
            <p>Monday – Friday</p>
            <p>9:00 AM – 5:00 PM</p>
          </div>
        </div>
      </div>

      <style>{`
        .contact-grid {
          margin-top: 30px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
          text-align: left;
        }

        .contact-box {
          background: #f9fbfd;
          border: 1px solid #dbe1ea;
          border-radius: 16px;
          padding: 22px;
        }

        .contact-box h2 {
          margin-top: 0;
          margin-bottom: 12px;
          font-size: 1.15rem;
          color: #2f6f89;
        }

        .contact-box p {
          margin: 8px 0;
          font-size: 1rem;
          color: #4b5563;
        }

        @media (max-width: 900px) {
          .contact-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
}